import request from '@/utils/request';

// 用户信息
export async function getUser() {
  return request.get('nxin.usercenter.user.get/1.0');
}

// 栏目列表
export async function getColumns() {
  return request.get('nxin.information.help.columns/1.0');
}
